import { render, staticRenderFns } from "./BriefReport.vue?vue&type=template&id=3b394d2e&scoped=true&"
import script from "./BriefReport.vue?vue&type=script&lang=js&"
export * from "./BriefReport.vue?vue&type=script&lang=js&"
import style0 from "./BriefReport.vue?vue&type=style&index=0&id=3b394d2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b394d2e",
  null
  
)

export default component.exports